import useMountEffect from '@restart/hooks/useMountEffect';
import React, { createContext, useState, useRef } from 'react';
import { useStore } from 'react-redux';

import { NTRIP_BASE_URL } from '@/config';
import useGPSCommand from '@/hooks/command/mavlink/useGPSCommand';

const NTRIPContext = createContext(null);
export { NTRIPContext };

const Provider = ({ children }) => {
  const store = useStore();
  const [robotOptions, setRobotOptions] = useState({
    byId: {},
    allIds: [],
  });
  const ntripWorker = useRef();
  const gpsCommand = useGPSCommand();

  useMountEffect(() => {
    ntripWorker.current = new Worker('./workers/ntrip-worker.js');

    ntripWorker.current.onmessage = ({ data }) => messageHandler(data);
  });

  const messageHandler = ({ command, data }) => {
    switch (command) {
      case 'responseConnect':
        if (!data.success) {
          removeRobotOption(data.data.robotId);
        }
        break;

      case 'responseDisconnect':
        if (data.success) {
          removeRobotOption(data.data.robotId);
        }
        break;

      case 'sendRTCM':
        if (data.success) {
          const { robotId, flags, chunk } = data.data;
          const robot = store.getState().robots.find(({ id }) => id === robotId);

          gpsCommand.sendRTCM(robot, flags, chunk);
        }
        break;

      default:
        break;
    }
  };

  const removeRobotOption = (robotId) => {
    // Robot ID 해당 정보 제거
    const nextRobotOptions = { ...robotOptions };
    delete nextRobotOptions.byId[robotId];
    nextRobotOptions.allIds = nextRobotOptions.allIds.filter((id) => id !== robotId);
    setRobotOptions(nextRobotOptions);
  };

  const connect = (robotId, options) => {
    // Robot ID 해당 정보 추가
    const nextRobotOptions = { ...robotOptions };
    nextRobotOptions.byId[robotId] = options;
    nextRobotOptions.allIds.push(robotId);
    setRobotOptions(nextRobotOptions);

    ntripWorker.current.postMessage({
      command: 'requestConnect',
      data: { baseUrl: NTRIP_BASE_URL, robotId, options },
    });
  };

  const disconnect = (robotId) => {
    ntripWorker.current.postMessage({
      command: 'requestDisconnect',
      data: { robotId },
    });
  };

  const ntrip = {
    connect,
    disconnect,
    robotOptions,
  };

  return <NTRIPContext.Provider value={ntrip}>{children}</NTRIPContext.Provider>;
};

export default Provider;
